export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";